export const FeedbackIcon = (
  <svg
    fill="#23AA49"
    width="100px"
    height="100px"
    viewBox="0 0 30 30"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M20.5 9s-.3 0-.4.2l-5.4 5.5-.6.3c-.2 0-.4 0-.6-.3L11 12.2c-.6-.5-1.3.2-.8.7l2.4 2.4c.4.4 1 .6 1.4.6.5 0 1-.2 1.4-.6L21 10c.2-.4 0-1-.5-1zm-19-8C.7 1 0 1.7 0 2.5v19c0 .8.7 1.5 1.5 1.5H5v4.5c0 .3 0 .6.2 1 0 .2.4.4.6.5.6 0 1-.2 1.6-.7l5.3-5.3h15.8c.8 0 1.5-.7 1.5-1.5v-19c0-.8-.7-1.5-1.5-1.5zm0 1h27c.3 0 .5.2.5.5v19c0 .3-.2.5-.5.5H12.1l-5.4 5.7c-.5.5-.6 0-.6-.2v-5c0-.3-.2-.5-.5-.5h-4c-.3 0-.5-.2-.5-.5v-19c0-.3.2-.5.5-.5z" />
  </svg>
);